/* eslint-disable */
export default {
  clientId: 'YUMx5nI8ZU8Ap8pm',
  clientVersion: 'undefined',
  packageName: 'drive.mypikpak.com',
  timestamp: '1748484283154',
  algorithms: [{"alg":"md5","salt":"fyZ4+p77W1U4zcWBUwefAIFhFxvADWtT1wzolCxhg9q7etmGUjXr"},{"alg":"md5","salt":"uSUX02HYJ1IkyLdhINEFcCf7l2"},{"alg":"md5","salt":"iWt97bqD/qvjIaPXB2Ja5rsBWtQtBZZmaHH2rMR41"},{"alg":"md5","salt":"3binT1s/5a1pu3fGsN"},{"alg":"md5","salt":"8YCCU+AIr7pg+yd7CkQEY16lDMwi8Rh4WNp5"},{"alg":"md5","salt":"DYS3StqnAEKdGddRP8CJrxUSFh"},{"alg":"md5","salt":"crquW+4"},{"alg":"md5","salt":"ryKqvW9B9hly+JAymXCIfag5Z"},{"alg":"md5","salt":"Hr08T/NDTX1oSJfHk90c"},{"alg":"md5","salt":"i"}],
};
